// extracted by mini-css-extract-plugin
module.exports = {"container":"_2PeBHuH4jSy4QVuMbYa4U2"};